import { WorkItemStore } from "WorkItemTracking/Scripts/TFS.WorkItemTracking";
import { RollupCalculationSettings } from "WorkItemTracking/Scripts/Utils/RollupHelpers";

// NOTE: The dependencies referenced here are strictly compile time interfaces.
// This interface file is referenced by code which is not guaranteed to have pre - loaded Boards Rollup queries
import { RollupQueryWorkItemResult, WorkItemsRecency } from "Analytics/Boards/RollupQueries/RollupQuery";

export interface RollupProgressBar {
    completedWorkCount: number;
    totalWorkCount: number;
    errorMessage?: string;
}

/**
 * Describes the public contracts of RollupDataProvider for compile time consumers.
 *
 */
export interface IRollupDataProvider {
    resetWorkItemList(workItemIds: number[]): void;
    checkAndUpdateWorkItemIds(updatedWorkItemIds: number[]): number[];
    setStore(store: WorkItemStore);
    resetRollupData(workItemResetUtcTimestamp: number, workItemLinksResetUtcTimestamp: number): void;
    getRollupData(workItemId: number, interactive?: boolean): Promise<RollupProgressBar>;
    getTooltipLabel(): IPromise<string>;
    getRollupMetric(): RollupCalculationSettings;
    getWitRecencyData(workItemIds: number[]): IPromise<WorkItemsRecency>;
    runQueryDelayed(pageWorkItemIds: number[], retriesMade: number, initialStartTime: number): Promise<RollupQueryWorkItemResult[]>;
    isAnalyticsCaughtUp(axDates: WorkItemsRecency, opStoreDates: WorkItemsRecency): boolean;
}
